import { jsx } from '@emotion/react/jsx-runtime';
import { createComponentWithRef, useSlot } from '@nettbureau/core';
import { BaseInput } from '../base-input.js';
import { useTextInput } from './use-text-input.js';

/**
 * An input component with no styling providing a foundation for a text input field.
 */ const TextInput = createComponentWithRef((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('TextInput', props, ref);
    const { className, color, css, lineHeight, size, tabIndex, weight, ...inputProps } = mergedProps;
    const textInputProps = useTextInput(inputProps, mergedRef);
    return /*#__PURE__*/ jsx(BaseInput, {
        "data-text-input": true,
        ...textInputProps,
        className: className,
        color: color,
        css: css,
        lineHeight: lineHeight,
        size: size,
        tabIndex: tabIndex,
        weight: weight,
        children: /*#__PURE__*/ jsx("input", {})
    });
});

export { TextInput };
//# sourceMappingURL=text-input.js.map
